"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("./encoding");
const typechecks_1 = require("./typechecks");
const prefixes = {
    string: "string:",
    bytes: "bytes:",
};
/**
 * Encodes non-circular JavaScript objects and primitives into JSON.
 * Used for encoding/decoding transactions but works for kind of data consisting of the supported types.
 *
 * Supported types:
 * - boolean
 * - number
 * - null
 * - object
 * - Array
 * - string
 * - Uint8Array
 */
class TransactionEncoder {
    static toJson(data) {
        if (typeof data === "number" || typeof data === "boolean") {
            return data;
        }
        if (data === null) {
            return null;
        }
        if (typeof data === "string") {
            return `${prefixes.string}${data}`;
        }
        if (typechecks_1.isUint8Array(data)) {
            return `${prefixes.bytes}${encoding_1.Encoding.toHex(data)}`;
        }
        if (Array.isArray(data)) {
            return data.map(TransactionEncoder.toJson);
        }
        // Exclude special kind of objects like Array, Date or Uint8Array
        // Object.prototype.toString() returns a specified value:
        // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
        if (typeof data === "object" &&
            data !== null &&
            Object.prototype.toString.call(data) === "[object Object]") {
            const out = {};
            for (const key of Object.keys(data)) {
                const value = data[key];
                // Skip dictionary entries with value `undefined`, just like native JSON:
                // > JSON.stringify({ foo: undefined })
                // '{}'
                if (value === undefined)
                    continue;
                // tslint:disable-next-line: no-object-mutation
                out[key] = TransactionEncoder.toJson(value);
            }
            return out;
        }
        throw new Error("Cannot encode type to JSON");
    }
    static fromJson(data) {
        if (typeof data === "number" || typeof data === "boolean") {
            return data;
        }
        if (data === null) {
            return null;
        }
        if (typeof data === "string") {
            if (data.startsWith(prefixes.string)) {
                return data.slice(prefixes.string.length);
            }
            if (data.startsWith(prefixes.bytes)) {
                return encoding_1.Encoding.fromHex(data.slice(prefixes.bytes.length));
            }
            throw new Error("Found string with unknown prefix");
        }
        if (Array.isArray(data)) {
            return data.map(TransactionEncoder.fromJson);
        }
        // Exclude special kind of objects like Array, Date or Uint8Array
        // Object.prototype.toString() returns a specified value:
        // http://www.ecma-international.org/ecma-262/7.0/index.html#sec-object.prototype.tostring
        if (typeof data === "object" &&
            data !== null &&
            Object.prototype.toString.call(data) === "[object Object]") {
            const out = {};
            for (const key of Object.keys(data)) {
                // tslint:disable-next-line: no-object-mutation
                out[key] = TransactionEncoder.fromJson(data[key]);
            }
            return out;
        }
        throw new Error("Cannot decode type from JSON");
    }
}
exports.TransactionEncoder = TransactionEncoder;
//# sourceMappingURL=transactionencoder.js.map